import { render, staticRenderFns } from "./ArticleCardSkeleton.vue?vue&type=template&id=322cc20a&scoped=true&"
import script from "./ArticleCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ArticleCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCardSkeleton.vue?vue&type=style&index=0&id=322cc20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322cc20a",
  null
  
)

export default component.exports